import styled from 'styled-components';

export const GridContainer = styled.div`
  margin: 0 auto;
  width: ${props => props.width || '100%'};
  height: 100%;
  margin-bottom: 24px;

  .full-height {
    min-height: 100%;
  }
`;

export const Row = styled.div.attrs({
  className: 'row',
})``;

export const Column = styled.div.attrs(({ colSpan }) => ({
  className: colSpan || 'col-12',
}))``;
